import { makeStyles } from "@material-ui/core/styles";
import archWithCircles from "../../../assets/images/userProfile/archWithCircles.svg";

const useStyles = makeStyles((theme) => ({
  taggedSkills: {
    margin: "40px 0 0",
    width: 400,
    [theme.breakpoints.down("xs")]: {
      width: 300,
    },
  },
  semiCircle2: {
    position: "relative",
    background: `url(${archWithCircles}) no-repeat`,
    height: 200,
    width: 200,
    backgroundSize: "contain",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      width: 150,
      height: 150,
    },
  },
  semiCircleTitle2: (props) => {
    const txtColor =
      props.appTheme === "CLASSIC"
        ? "#777"
        : props.appTheme === "LIGHT"
        ? "#777"
        : "#fff";
    return {
      color: txtColor,
      position: "absolute",
      left: -10,
      textAlign: "center",
      fontSize: 11,
      [theme.breakpoints.down("xs")]: {
        fontSize: 10,
        left: -12,
        width: 50,
        lineHeight: "12px",
      },
      "& b": (props) => {
        const txtColor =
          props.appTheme === "CLASSIC"
            ? "#202f43"
            : props.appTheme === "LIGHT"
            ? "#202f43"
            : "#fff";
        return {
          color: txtColor,
          fontSize: 35,
          lineHeight: 1,
          display: "block",
          fontWeight: 600,
          [theme.breakpoints.down("xs")]: {
            fontSize: "22px !important",
            marginTop: 8,
          },
        };
      },
    };
  },
  skillList: (props) => {
    return {
      padding: 0,
      listStyle: "none",
      position: "absolute",
      left: 250,
      height: 200,
      width: 160,
      display: "flex",
      flexDirection: "column",
      [theme.breakpoints.down("xs")]: {
        width: 100,
        left: 210,
      },
      "& li": (props) => {
        return {
          display: "flex",
          cursor: "pointer",
          border: "1px solid #CCCCCC",
          background: "#fff",
          borderRadius: 30,
          height: 34,
          minHeight: 34,
          position: "relative",
          paddingLeft: "10px !important",
          marginBottom: "0 !important",
          fontSize: 12,
          [theme.breakpoints.down("xs")]: {
            height: "28px !important",
            minHeight: "28px !important",
          },
          "&.selected-skill": {
            background: "#FFF5EC",
            border: "solid 1px #F3994E",
            "& .count": {
              background: "#F3994E",
              color: "#fff",
            },
          },
          "&:nth-child(1)": {
            marginLeft: "-105px",
            marginTop: "-18px",
            [theme.breakpoints.down("xs")]: {
              marginTop: 10,
            },
          },
          "&:nth-child(2)": {
            marginLeft: "-80px",
            marginTop: 14,
            [theme.breakpoints.down("xs")]: {
              marginTop: 9,
            },
          },
          "&:nth-child(3)": {
            marginLeft: "-60px",
            marginTop: 18,
            [theme.breakpoints.down("xs")]: {
              marginTop: 10,
            },
          },
          "&:nth-child(4)": {
            marginLeft: "-80px",
            marginTop: 18,
            [theme.breakpoints.down("xs")]: {
              marginTop: 10,
            },
          },
          "&:nth-child(5)": {
            marginLeft: "-105px",
            marginTop: 14,
            [theme.breakpoints.down("xs")]: {
              marginTop: 9,
            },
          },
        };
      },
    };
  },
  count: {
    minWidth: 44,
    width: 44,
    height: 33,
    borderRadius: 30,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#E3E5E8",
    fontSize: 12,
    [theme.breakpoints.down("xs")]: {
      marginLeft: 10,
      height: 28,
      marginRight: -1,
    },
  },
  noSkill: {
    color: "#ccc",
    alignItems: "center",
  },
  dotsWrapper: {
    textAlign: "center",
  },
  dot: (props) => {
    const border =
      props.appTheme === "CLASSIC"
        ? "1px solid #707070"
        : props.appTheme === "LIGHT"
        ? "1px solid #707070"
        : "1px solid #fff";
    return {
      height: "10px",
      width: "10px",
      border: border,
      borderRadius: "50%",
      display: "inline-block",
      margin: 2,
      cursor: "pointer",
    };
  },
  filledBackground: (props) => {
    const bgColor =
      props.appTheme === "CLASSIC"
        ? "#4A4747"
        : props.appTheme === "LIGHT"
        ? "#4A4747"
        : "#fff";
    return {
      backgroundColor: bgColor,
    };
  },
  skillName: {
    textAlign: "center",
    textTransform: "uppercase",
    margin: "5px 0 0",
  },
  skillNameList: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  // transition
  animateCss: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    opacity: 1,
    // animationName: "$fadeInOpacity",
    // animationIterationCount: 1,
    // animationTimingFunction: "ease-in",
    // animationDuration: "1.8s",
  },
  "@keyframes fadeInOpacity": {
    "0%": {
      opacity: 1,
      transform: "translateY(0)",
    },
    "100%": {
      opacity: 0,
      transform: "translateY(-5rem)",
    },
  },
}));

export default useStyles;
